import { queryClient } from './queryClient';

/** Refetch org/tournament diamonds and all game lists after a diamond mutation. */
export function invalidateDiamondAndGameQueries(): void {
  queryClient.invalidateQueries({
    predicate: query => {
      const key = query.queryKey.map(String).join(' ');
      return key.includes('diamonds') || key.includes('/games');
    },
  });
}
